import React, { PureComponent } from 'react';
import { IChartSeries } from 'types';
import ChartAttributeItem from './chart-attribute-item';
import { ICON_ADD, ICON_CHECK } from 'icons';
import Button from 'ui/button';
import { Loader } from 'ui/loader';
interface ChartEditAttributesProps {
  series: IChartSeries[];
  onChange: (id: string, update: IChartSeries) => void;
  onCreate: (model: IChartSeries) => Promise<any>;
  onRemove: (id: string) => void;
}
class ChartEditAttributes extends PureComponent<ChartEditAttributesProps> {
  state = {
    pendingCreate: false,
    create: false,
    error: false
  };

  handleCreateOpen = () => this.setState({ create: { custom: true } });

  handleCreateSave = async() => {
    this.setState({ pendingCreate: true });
    try {
      await this.props.onCreate(this.state.create);
      this.setState({ create: false, pendingCreate: false, error: false });
    } catch (error) {
      this.setState({ error, pendingCreate: false });
    }
  };

  handleUpdateCreate = (id, update) => {
    this.setState({ create: { ...this.state.create, ...update } });
  };

  render() {
    const { series, onChange, onRemove } = this.props;
    const { error, create, pendingCreate } = this.state;
    return (
      <div className="fill scroll">
        {series.map(series => (
          <ChartAttributeItem
            key={series.id}
            item={series}
            onChange={onChange}
            onRemove={onRemove}
          />
        ))}
        {create && !pendingCreate && (
          <ChartAttributeItem item={create} onChange={this.handleUpdateCreate} />
        )}

        <div className="column h-center padding">
          {error && <div className="text-error">{error}</div>}
          {pendingCreate && <Loader message="Doing some creative stuff" />}
          {!create && (
            <Button icon={ICON_ADD} flat="Add new attribute" onClick={this.handleCreateOpen} />
          )}
          {create && (
            <Button
              icon={ICON_CHECK}
              raised
              disabled={pendingCreate}
              flat="Save new attribute"
              onClick={this.handleCreateSave}
            />
          )}
        </div>
      </div>
    );
  }
}

export default ChartEditAttributes;
